import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'lib-bo-auth-submit-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bo-auth-submit-button.component.html',
  styleUrls: ['./bo-auth-submit-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoAuthSubmitButtonComponent {
  readonly label = input.required<string>();
  readonly loading = input(false);
  readonly disabled = input(false);
  readonly variant = input<'primary' | 'secondary' | 'gradient'>('primary');

  readonly displayLabel = computed(() => (this.loading() ? 'Cargando...' : this.label()));
}
